// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dollar-amount-field {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 160px;
}

.dollar-amount-field-fill {
  display: flex;
  flex: 1;
  width: auto;
}

.dollar-amount-prefix {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--secondary-text-color);
  pointer-events: none;
  z-index: 1;
}

/* Room for the "\$" prefix; wins over context input padding via the extra
   class. Other input styling (border, height) comes from context. */
.dollar-amount-field .dollar-amount-input {
  padding-left: 22px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/billing/DollarAmountInput.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,kCAAkC;EAClC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;oEACoE;AACpE;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".dollar-amount-field {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  width: 160px;\n}\n\n.dollar-amount-field-fill {\n  display: flex;\n  flex: 1;\n  width: auto;\n}\n\n.dollar-amount-prefix {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--secondary-text-color);\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* Room for the \"$\" prefix; wins over context input padding via the extra\n   class. Other input styling (border, height) comes from context. */\n.dollar-amount-field .dollar-amount-input {\n  padding-left: 22px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
